import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { CompanyInformationState } from "../types";

const getters: GetterTree<CompanyInformationState, RootState> = {
  getZipcode: (state) => state.zipcode,
  getCity: (state) => state.city,
  getAddressLine1: (state) => state.addressLine1,
  getAddressLine2: (state) => state.addressLine2,
  getWebsiteUrl: (state) => state.websiteUrl,
  getCountry: (state) => state.country,
  getBillingContactName: (state) => state.billingContactName,
  getBillingContactEmail: (state) => state.billingContactEmail,
  getName: (state) => state.name,
};

export default getters;
